/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { isPresent } from '@ember/utils';
import Component from '@glimmer/component';

export interface ISelectFilterDefinitionArgs {
  possibleValues: TSelectOption[];
  searchField?: string;
  renderInPlace?: boolean;
  horizontalPosition?: 'left' | 'right' | 'auto';
  valueProp?: keyof TSelectOption;
}

export default class FiltersSelectFilterComponent extends Component<
  FilterComponentSignature<ISelectFilterDefinitionArgs>
> {
  get searchField() {
    return this.args.componentArgs.searchField ?? 'key';
  }

  get selected() {
    const { componentArgs, values = [], multiple } = this.args;
    const valuesStr = new Set(values.map(String));

    if (multiple) {
      return componentArgs?.possibleValues?.filter((o) => {
        const v = this.getValue(o);
        return v && valuesStr.has(v);
      });
    } else {
      return values.length > 0
        ? componentArgs?.possibleValues?.find((o) => this.getValue(o) === values[0]?.toString())
        : undefined;
    }
  }

  getValue(o: TSelectOption) {
    const v = o[this.args.componentArgs.valueProp ?? 'key'];
    return isPresent(v) ? `${v}` : undefined;
  }

  getValues(options: (TSelectOption | undefined)[]) {
    return options.reduce((acc: string[], o) => {
      const v = o && this.getValue(o);
      if (isPresent(v)) {
        acc.push(v as string);
      }
      return acc;
    }, []);
  }

  @action
  valuesDidChange(options: TSelectOption[]) {
    this.args.onChange?.(this.getValues(options));
  }

  @action
  singleValueDidChange(option?: TSelectOption) {
    this.args.onChange?.(this.getValues([option]));
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::SelectFilter': typeof FiltersSelectFilterComponent;
    'filters/select-filter': typeof FiltersSelectFilterComponent;
  }
}
